import React, { useState, useEffect } from "react";
import { motion } from "framer-motion"; // Importing Framer Motion
import "../../assets/styles/comone.css"; // Ensure you have a CSS file for styling

const Comone = () => {
  const [currentTime, setCurrentTime] = useState(new Date());
  const [userTimeZone, setUserTimeZone] = useState("");

  useEffect(() => {
    // Update time every 60 seconds
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000);

    // Get user's timezone
    setUserTimeZone(Intl.DateTimeFormat().resolvedOptions().timeZone);

    // Cleanup interval on component unmount
    return () => clearInterval(interval);
  }, []);

  // Format month in uppercase
  const month = currentTime.toLocaleString("en-US", { month: "long" }).toUpperCase();
  const day = currentTime.getDate();

  // Format time with AM/PM, using the user's local timezone
  const timeOptions = {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  };
  const timeString = currentTime
    .toLocaleTimeString(undefined, timeOptions) // `undefined` defaults to user's locale
    .replace(/(AM|PM)/, " $1");

  return (
    <div className="banner-container">
      <motion.p
        className="banner-text"
        initial={{ opacity: 0, y: 50 }} // Start below
        whileInView={{ opacity: 1, y: 0 }} // Move up
        viewport={{ once: false, amount: 0.3 }} // Trigger at 30% visibility
        transition={{ duration: 1.5, ease: "easeInOut", delay: 0.2 }}
      >
         {month} {day} - {timeString} ({userTimeZone})
      </motion.p>
    </div>
  );
};

export default Comone;
